import React, { ReactElement } from 'react'
import Divider from '../Divider'
import CreateOverview from './CreateOverview'

const CreatePanel = (): ReactElement => {
    return (
        <div className="panel">
            <Divider />
            <CreateOverview />
        </div>
    )
}

export default CreatePanel
